export const contentsAndCollectionsConstants = {
	ACTION_SUCCESS: 'ACTION_SUCCESS'
}
